// extracted by mini-css-extract-plugin
export default {"discussContainer":"DiscussionPanel_discussContainer__TnTCY","toggleReplyText":"DiscussionPanel_toggleReplyText__gS4Y-","toggleReplyIcon":"DiscussionPanel_toggleReplyIcon__gpq3o"};